export default __webpack_public_path__ + "static/media/Rewards & Benefits - img.5041d5a6.png";